import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { IsLoginModule } from 'projects/is-ui-kit/src/lib/components/is-login/is-login.module';
import { toastrConfig } from '../configs';
import { ActionToastComponent } from './utils/custom-notifiers/action-toast/action-toast.component';
import { MatIconModule } from '@angular/material/icon';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
export const customNotifiers = [ActionToastComponent];

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }
  getTranslation(lang: string): Observable<any> {
    return forkJoin([
      this.http.get(`assets/_i18n/${lang}.json`),
      this.http.get(`assets/i18n/${lang}.json`)
    ]).pipe(
      map(([local, global]) => {
        return { ...global, ...local };
      })
    );
  }
}
export function _translateHttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new CustomTranslateLoader(http);
}
@NgModule({
  declarations: customNotifiers,
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: _translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(toastrConfig),
    IsLoginModule,
    /** important! you never should import again MatNativeDateModule or you will ovveride this */
    MatNativeDateModule,
    /** importing MatButtonModule because its used in the custom toastr */
    MatButtonModule,
    MatIconModule
  ]
})
export class UtilsInitializerModule { }